import Vue from 'vue';

// import Raven from 'raven-js';
// import RavenVue from 'raven-js/plugins/vue';
// import VueRaven from 'vue-raven';
import * as Sentry from '@sentry/vue';

import Moment from 'moment';
import VueI18n from 'vue-i18n';
import { dateTimeFormats } from './_helpers/date_time_formats.js';
import { METRICS } from './_helpers/constants.js';

import VeeValidate from 'vee-validate';
import en from 'vee-validate/dist/locale/en';
import ru from 'vee-validate/dist/locale/ru';

import VTooltip from 'v-tooltip';
import VueNoty from 'vuejs-noty';
import SocialSharing from 'vue-social-sharing';
import Sticky from 'vue-sticky-directive';

import { configureAxios, slovene_pluralization, default_pluralization, isDomainRu } from '@/_helpers/utils.js'
import 'moment-duration-format';
import '@/components_new/index.js';
import '@/filters/index.js';
import vuetify from './plugins/vuetify.ts';
// import VueColumnsResizable from 'vue-columns-resizable/plugins/vue-columns-resizable';
import App from './App.vue';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import router from './routes_new/index.js';
import store from './store/index.ts';
import { sync } from 'vuex-router-sync'; // Чтобы иметь доступ к передаваемым параметрам в рамках сторы

import 'vuejs-noty/dist/vuejs-noty.css';
import 'vue-draggable-resizable/dist/VueDraggableResizable.css';
import BrowserStore from 'store'

import VueApexCharts from 'vue-apexcharts';
Vue.use(VueApexCharts);
Vue.component('Apexchart', VueApexCharts);

sync(store, router);

Vue.config.productionTip = false;
const isDev = process.env.NODE_ENV !== 'production';
Vue.config.performance = isDev;

const app = {
  app: null
};

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    Vue,
    environment: 'production',
    dsn: 'https://f0f46023342910aa21b77c55df0d39cb@sentry.vcv.team/3',
    integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,

    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    // tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.ru\/api/],

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0
  });
}

configureAxios(app);
Moment.locale('ru');
Vue.prototype.$moment = Moment;
// ArrayIncludesPolyfill()

VueI18n.prototype.getChoiceIndex = function(choice, choicesLength) {
    // this === VueI18n instance, so the locale property also exists here
    if (this.locale !== 'ru') {
        // proceed to the default implementation
        return default_pluralization(choice, choicesLength, this.locale, this.pluralizationRules);
    }

    return slovene_pluralization(choice, choicesLength);
}
Vue.use(VueI18n);
Vue.use(SocialSharing)
const tooltipOptions = {
    popover: {
        defaultHandleResize: true
    }
}
Vue.use(VTooltip, tooltipOptions)
Vue.use(Sticky)

Vue.use(VueNoty, {
    layout: 'bottomRight',
    progressBar: false,
    maxVisible: 1,
    timeout: 3000,
    killer: true
})
const i18n = new VueI18n({
    locale: store.state.locale.value,
    silentTranslationWarn: true,
    // fallbackLocale: 'en',
    dateTimeFormats
    // messages
})

Vue.use(VeeValidate, {
    i18n,
    classes: true,
    dictionary: { en, ru }
})

Vue.mixin({
  computed: {
    yandex_counter() {
        if (!METRICS) {
            return '';
        }

        let yandexId = '';
        const host = window.location.hostname;
        const hostArray = host.split('.');
        const domain = `${hostArray.slice(hostArray.length - 1)}`;
        const location = window.location.pathname;

        if (domain === 'ru' || domain === 'localhost' || domain === 'team') {
            if (location.indexOf('/registration/') === 0) {
                yandexId = METRICS.yandexId.registration_ru;
            } else {
                yandexId = METRICS.yandexId.ru;
            }
        } else {
            if (location.indexOf('/registration/') === 0) {
                yandexId = METRICS.yandexId.registration_en;
            } else {
                yandexId = METRICS.yandexId.ai;
            }
        }

        return window['yaCounter' + yandexId];
    },
    yandex_id() {
        if (!METRICS) {
            return '';
        }

        let yandexId = '';
        const host = window.location.hostname;
        const hostArray = host.split('.');
        const domain = `${hostArray.slice(hostArray.length - 1)}`;
        const location = window.location.pathname;

        if (domain === 'ru' || domain === 'localhost' || domain === 'team') {
            if (location.indexOf('/registration/') === 0) {
                yandexId = METRICS.yandexId.registration_ru;
            } else {
                yandexId = METRICS.yandexId.ru;
            }
        } else {
            if (location.indexOf('/registration/') === 0) {
                yandexId = METRICS.yandexId.registration_en;
            } else {
                yandexId = METRICS.yandexId.ai;
            }
        }

        return yandexId;
    },

    is_production() {
        return process && process.env && process.env.NODE_ENV === 'production';
    }
  },
  methods: {
    $ga(params) {
        if (window.ga === undefined) {
            return false;
        }
        window.ga(function(tracker) {
            var clientId = tracker.get('clientId') // получаем clientId из Google Analytics
            document.cookie = '_ga_cid=' + clientId + '; path=/'; // сохраняем cookie в _ga_cid
            window.ga('set', 'dimension1', clientId); // записываем clientId пользователя в параметр
        });
        window.ga('set', '&uid', params.email); // когда рекрутер авторизуется / регистрируется / оставляет контактные данные, запишите вместо ‘1234’ идентификатор, который присвоился пользователю в БД при регистрации, если пользователь не зарегистрирован или не авторизован (у него вообще нет id в базе данных), оставьте пустое значение ga('set', '&uid', ‘’)
        window.ga('set', 'dimension4', params.email); // запишите userId аналогично комментарию выше
        window.ga('set', 'dimension5', params.company_name); // запишите название компании аналогично комментарию выше
        window.ga('set', 'dimension6', params.geo); // запишите регион компании аналогично комментарию выше
        window.ga('set', 'dimension11', params.reg1); // запишите 'true' если пользователь прошёл первый шаг регистрации компании, в противном случае - пусто
        window.ga('set', 'dimension12', params.reg2); // запишите 'true' если пользователь прошёл второй шаг регистрации компании, в противном случае - пусто
        window.ga('set', 'dimension13', 'user'); // запишите 'user' если пользователь авторизовался, в противном случае - пусто
        window.ga('send', 'pageview')
    },
    $tr(v, options, params) {
        const availableLocales = store.getters['services/listLocales'];
        if (params && params.locale && params.locale !== store.state.locale.value && params.isRequested !== params.locale) {
            const hasLocale = availableLocales && availableLocales.length ?  !!availableLocales.find(item => item === params.locale) : false;

            if (!hasLocale) {
                store.commit('services/setListLocales', params.locale);
                store.dispatch('services/get_locales', params.locale)
                    .then((res) => {
                        this.$i18n.setLocaleMessage(params.locale, res.data.data[0]);
                        window.$tr(v, options, Object.assign({}, params, {
                            isRequested: params.locale
                        }));
                        return;
                    })
                    .catch(() => {
                        window.$tr(v, options, params);
                        return;
                    })
            }
        }

        if (this.$i18n && v && this.$i18n.locale && !this.$i18n.te(v, this.$i18n.locale) && this.$store.getters['user/isAdmin'] && !this.is_production) {
            let keys = this.$store.getters['services/list'];
            if (keys.indexOf(v) === -1) {
                this.$store.dispatch('services/save_tr_key', v);
            }
        }
        if (params && params.locale) {
            return this.$t(v, params.locale, options)
        }
        return params && params.is_pluralization ? this.$tc(v, options) : this.$t(v, options);
    }
  }
})

const domainRu = isDomainRu();
const location = window.location.pathname;
let yandexId = '';
    /* SPA metrix */
if (process.env.NODE_ENV === 'production') {
    /* отмечаем переходы по страницам */

    router.afterEach((to, from) => {
        if (domainRu) {
            yandexId = location === '/registration/ru' ? METRICS.yandexId.registration_ru : METRICS.yandexId.ru;
        } else {
            yandexId = location === '/registration/en' ? METRICS.yandexId.registration_en : METRICS.yandexId.ai;
        }

        if (window['yaCounter' + yandexId] !== undefined) {
            window['yaCounter' + yandexId].hit(to.fullPath);
        }
    });
}
router.beforeEach((to, from, next) => {
    // if (to.query && to.query.onboadring === 'true') {
    //     BrowserStore.set('onboadring', true);
    // } else if (to.query && to.query.onboadring === 'false') {
    //     BrowserStore.set('onboadring', false);
    // }

    if (to.query.is_ios) {
        BrowserStore.set('is_ios', to.query.is_ios ? JSON.parse(to.query.is_ios) : false)
    } else if (to.query.is_ios === false) {
        BrowserStore.set('is_ios', false)
    }
    if (to.query.is_show_bar) {
        BrowserStore.set('is_show_bar', to.query.is_show_bar ? JSON.parse(to.query.is_show_bar) : false)
    } else if (to.query.is_show_bar === false) {
        BrowserStore.set('is_show_bar', false)
    }

    next();
});
app.app = new Vue(Vue.util.extend({
    vuetify,
    i18n,
    router,
    store,
    render(h) {
        return h(App)
    }
}))

app.app.$mount('#main')
